module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Justice-League.01e70cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Justice-League.jpg
// module id = +WN5
// module chunks = 0